import { DateTimeSelect, InspectionTenantCategorySelect, OrderServiceSelect, SharedForm } from '@components';
import { L } from '@lib';
import { IDate } from '@models';
import { InspectionCategory } from '@services';
import { useStore } from '@stores';
import { Rules } from '@utils';
import { Col, Form, Row, Switch, Typography } from 'antd';
import { FormInstance } from 'antd/lib';
import { observer } from 'mobx-react';
import React from 'react';

const { Text } = Typography;

interface IProps {
  dropOffDate?: IDate;
  requestForm: FormInstance<any>;
  selectedInspections: InspectionCategory[];
  setDropOffDate: (value: IDate) => void;
  setSelectedInspections: (inspections: InspectionCategory[]) => void;
}

export const AdditionalServiceDetailsTab: React.FC<IProps> = observer(({
  requestForm,
  dropOffDate,
  selectedInspections,
  setDropOffDate,
  setSelectedInspections,
}) => {
  const { serviceStore } = useStore();
  const { additionalSelectedServices } = serviceStore;

  return (
    <SharedForm
      hideButtons
      name="createBookingForm"
      form={requestForm}
      submitTitle={L('Confirm booking')}
      submitDisabled={!additionalSelectedServices.length}
    >
      <Row>
        <Col span={10}>
          <Form.Item
            required
            name="dropOffDate"
            rules={Rules.required}
            label={L('Drop off date & time')}
          >
            <DateTimeSelect dateTime={dropOffDate} setDate={setDropOffDate} />
          </Form.Item>
        </Col>
        <Col span={7}>
          <Form.Item name="whileWait" label={L('While you wait job')}>
            <Switch />
          </Form.Item>
        </Col>
        <Col span={7}>
          <Form.Item name="approval" label={L('Estimate approval required')}>
            <Switch />
          </Form.Item>
        </Col>
      </Row>
      <Row style={{ marginBottom: 12 }}>
        <Col span={24}>
          <Text style={{ fontSize: 13, fontWeight: 600, color: '#1a3353', marginBottom: 4, display: 'block' }}>
            Inspections
          </Text>
          <InspectionTenantCategorySelect
            allowClear
            selectedInspections={selectedInspections}
            setSelectedInspections={setSelectedInspections}
          />
        </Col>
      </Row>
      <OrderServiceSelect variant="additional" />
    </SharedForm>
  );
});
